module.exports = "build/assets/PensumPro-BoldItalic.f0571153.ttf";